import React from "react";

// Navigation
import { useNavigate } from "react-router-dom";

// components
import Img from "components/Img";
import Button from "components/UiKit/Button";

// Animation
import { Fade } from "react-awesome-reveal";

// Constants
import { frequentCustom } from "constans/landing";
import { initialStateFormat } from "constans/request-form";

// Type
import { FrequentCustomType } from "../type";

export const FrequentCustom: React.FC = () => {
  const navigate = useNavigate();

  const handlerClick = () => {
    localStorage.setItem("format", JSON.stringify(initialStateFormat));

    navigate("/request-form");
  };

  return (
    <div className="section-frequent-custom">
      <div className="wrapper flex flex-ai-start flex-direction-column-desktop">
        <div className="section-frequent-custom__left">
          <h4 className="section-frequent-custom__title">
            Our Most Frequent Custom Synthesis Requests
          </h4>
          <Fade cascade triggerOnce direction="left">
            <ul className="section-frequent-custom__ul">
              {frequentCustom.map((x: FrequentCustomType, i: number) => {
                return <li key={x.text || "" + i} className="section-frequent-custom__li">{x.text}</li>;
              })}
            </ul>
          </Fade>

          <Button
            type="button"
            color="green"
            variable="info"
            label="Send a request"
            onPress={handlerClick}
            className="display-block-web"
          />
        </div>
        <div className="section-frequent-custom__right">
          <Img
            name="frequent"
            alt="Laboratory image 2"
            className="section-frequent-custom__right-img"
          />
        </div>

        <Button
          color="green"
          type="button"
          variable="info"
          label="Send a request"
          onPress={handlerClick}
          className="display-block-mobile"
        />
      </div>
    </div>
  );
};

export default FrequentCustom;
